<script>
    import { isScreenSaverVisible } from "./stores";
    $: display = $isScreenSaverVisible ? "block" : "none";
    export let number = "";
</script>

<div
    role="presentation"
    class="screen-saver"
    id="screen-saver"
    style="display:{display};--number:'{number}'"
    on:click={() => {
        $isScreenSaverVisible = false;
    }}
/>

<style>
    .screen-saver {
        display: block;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-image: url("../assets/terminal_number_frame.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 50vh;
        background-color: #000;
        padding: 0;
        border: none;
        overflow: hidden;
        font-family: "Arial";
        font-size: 14px;
        color: #fff;
        text-align: center;
    }
    .screen-saver::after {
        content: var(--number);
        position: absolute;
        top: 50vh;
        transform: translateY(-50%) translateX(-50%);
        font-size: 20vh;
    }
</style>
